import type { IconProps } from '../types';

export function WaitlistsIcon({ className, title }: IconProps) {
  return (
    <svg
      viewBox="0 0 1200 1200"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
    >
      {title ? <title>{title}</title> : null}
      <g>
        <path
          d="m840 495c0-7.957-3.1602-15.586-8.7852-21.215-5.6289-5.625-13.258-8.7852-21.215-8.7852h-330c-10.719 0-20.621 5.7188-25.98 15s-5.3594 20.719 0 30 15.262 15 25.98 15h330c7.957 0 15.586-3.1602 21.215-8.7852 5.625-5.6289 8.7852-13.258 8.7852-21.215z"
          fill="currentColor"
        />
        <path
          d="m720 645c0-7.957-3.1602-15.586-8.7852-21.215-5.6289-5.625-13.258-8.7852-21.215-8.7852h-210c-10.719 0-20.621 5.7188-25.98 15s-5.3594 20.719 0 30 15.262 15 25.98 15h210c7.957 0 15.586-3.1602 21.215-8.7852 5.625-5.6289 8.7852-13.258 8.7852-21.215z"
          fill="currentColor"
        />
        <path
          d="m480 765c-10.719 0-20.621 5.7188-25.98 15s-5.3594 20.719 0 30 15.262 15 25.98 15h180c10.719 0 20.621-5.7188 25.98-15s5.3594-20.719 0-30-15.262-15-25.98-15z"
          fill="currentColor"
        />
        <path
          d="m600 345c0-7.957-3.1602-15.586-8.7852-21.215-5.6289-5.625-13.258-8.7852-21.215-8.7852h-180c-10.719 0-20.621 5.7188-25.98 15s-5.3594 20.719 0 30 15.262 15 25.98 15h180c7.957 0 15.586-3.1602 21.215-8.7852 5.625-5.6289 8.7852-13.258 8.7852-21.215z"
          fill="currentColor"
        />
        <path
          d="m480 975h225c10.719 0 20.621-5.7188 25.98-15s5.3594-20.719 0-30-15.262-15-25.98-15h-225c-10.719 0-20.621 5.7188-25.98 15s-5.3594 20.719 0 30 15.262 15 25.98 15z"
          fill="currentColor"
        />
        <path
          d="m420 495c0 16.57-13.43 30-30 30s-30-13.43-30-30 13.43-30 30-30 30 13.43 30 30"
          fill="currentColor"
        />
        <path
          d="m420 645c0 16.57-13.43 30-30 30s-30-13.43-30-30 13.43-30 30-30 30 13.43 30 30"
          fill="currentColor"
        />
        <path
          d="m420 795c0 16.57-13.43 30-30 30s-30-13.43-30-30 13.43-30 30-30 30 13.43 30 30"
          fill="currentColor"
        />
        <path
          d="m420 945c0 16.57-13.43 30-30 30s-30-13.43-30-30 13.43-30 30-30 30 13.43 30 30"
          fill="currentColor"
        />
        <path
          d="m930 1005c-7.957 0-15.586 3.1602-21.215 8.7852-5.625 5.6289-8.7852 13.258-8.7852 21.215v30c0 7.957-3.1602 15.586-8.7852 21.215-5.6289 5.625-13.258 8.7852-21.215 8.7852h-540c-7.957 0-15.586-3.1602-21.215-8.7852-5.625-5.6289-8.7852-13.258-8.7852-21.215v-870c0-7.957 3.1602-15.586 8.7852-21.215 5.6289-5.625 13.258-8.7852 21.215-8.7852h65.25c6.1992 17.531 17.672 32.711 32.848 43.453 15.176 10.746 33.309 16.527 51.902 16.547h240c18.594-0.019531 36.727-5.8008 51.902-16.547 15.176-10.742 26.648-25.922 32.848-43.453h65.25c7.957 0 15.586 3.1602 21.215 8.7852 5.625 5.6289 8.7852 13.258 8.7852 21.215v330c0 10.719 5.7188 20.621 15 25.98s20.719 5.3594 30 0 15-15.262 15-25.98v-330c0-23.871-9.4805-46.762-26.359-63.641s-39.77-26.359-63.641-26.359h-65.25c-6.1992-17.531-17.672-32.711-32.848-43.453-15.176-10.746-33.309-16.527-51.902-16.547h-240c-18.594 0.019531-36.727 5.8008-51.902 16.547-15.176 10.742-26.648 25.922-32.848 43.453h-65.25c-23.871 0-46.762 9.4805-63.641 26.359s-26.359 39.77-26.359 63.641v870c0 23.871 9.4805 46.762 26.359 63.641s39.77 26.359 63.641 26.359h540c23.871 0 46.762-9.4805 63.641-26.359s26.359-39.77 26.359-63.641v-30c0-7.957-3.1602-15.586-8.7852-21.215-5.6289-5.625-13.258-8.7852-21.215-8.7852zm-450-900h240c10.719 0 20.621 5.7188 25.98 15s5.3594 20.719 0 30-15.262 15-25.98 15h-240c-10.719 0-20.621-5.7188-25.98-15s-5.3594-20.719 0-30 15.262-15 25.98-15z"
          fill="currentColor"
        />
        <path
          d="m930 585c-51.719 0-101.32 20.543-137.89 57.113-36.57 36.57-57.113 86.168-57.113 137.89s20.543 101.32 57.113 137.89c36.57 36.57 86.168 57.113 137.89 57.113s101.32-20.543 137.89-57.113c36.57-36.57 57.113-86.168 57.113-137.89s-20.543-101.32-57.113-137.89c-36.57-36.57-86.168-57.113-137.89-57.113zm0 330c-35.805 0-70.141-14.223-95.461-39.539-25.316-25.32-39.539-59.656-39.539-95.461s14.223-70.141 39.539-95.461c25.32-25.316 59.656-39.539 95.461-39.539s70.141 14.223 95.461 39.539c25.316 25.32 39.539 59.656 39.539 95.461s-14.223 70.141-39.539 95.461c-25.32 25.316-59.656 39.539-95.461 39.539z"
          fill="currentColor"
        />
        <path
          d="m960 767.55v-62.551c0-10.719-5.7188-20.621-15-25.98s-20.719-5.3594-30 0-15 15.262-15 25.98v75c0.035156 7.9453 3.2148 15.551 8.8516 21.148l45 45c7.7227 6.6172 18.27 8.8672 28.02 5.9844 9.75-2.8828 17.379-10.512 20.262-20.262 2.8828-9.75 0.63281-20.297-5.9844-28.02z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
